export { useDeviceType } from "./useDevice";
